// Remove error if it is triggered
const removeError = (element, errorClass) => {
  if (element.classList.contains(errorClass)) {
    element.classList.remove(errorClass);
  }
};

export default removeError;
